import { useBuildHubSlashDealsUrl } from '@/components/nav/utils/url-builders';
import FullscreenMessage from '@/components/ui/layout/fullscreen-message';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

export const Route = createFileRoute('/(authenticated)/$hub/all/')({
  component: RouteComponent,
});

function RouteComponent() {
  const hubSlashDealsUrl = useBuildHubSlashDealsUrl();

  const navigate = useNavigate();
  useEffect(() => {
    navigate({ to: hubSlashDealsUrl });
  }, [hubSlashDealsUrl]);

  return (
    <FullscreenMessage>
      <div className="flex flex-col items-center justify-center">
        <h1 className="text-2xl">This route is moved to /deals</h1>
        <p className="text-gray-500">
          You will be redirected to the new route in a few seconds.
        </p>
      </div>
    </FullscreenMessage>
  );
}
